import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { FloatLabelType, MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-text-input',
  standalone: true,
  imports: [CommonModule, MatFormFieldModule, ReactiveFormsModule, MatInputModule, MatIconModule],
  templateUrl: './text-input.component.html',
  styleUrl: './text-input.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextInputComponent {
  @Input() label!: string;
  @Input() type: string = 'text';
  @Input() control!: FormControl;
  @Input() placeholder!: string;
  @Input() floatLabel: FloatLabelType = 'auto';
  @Input() value: any;

  @Input() passwordHide: boolean = false;
  @Input() isDisabled: boolean = false;

  @Output() textInputBlur = new EventEmitter<string>();

  onBlur(event: any) {
    this.textInputBlur.emit(event.target.value);
  }
}
